export enum DoctorChannel {
  CREATE = 'doctor::create',
  EDIT = 'doctor::patch',
  DELETE = 'doctor::delete',
}
